import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DataService } from '../../services/data.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-career-latest-jobs',
  templateUrl: './career-latest-jobs.component.html',
  styleUrls: ['./career-latest-jobs.component.scss'],
})
export class CareerLatestJobsComponent implements OnInit {
  @Input({ required: true }) pageData: any;

  @ViewChild('carousel') carousel: any;

  jobsItems: any[] = [];
  isLoaded: boolean = false;

  breakpoints = {
    0: {
        slidesPerView: 'auto',
        centeredSlides: true
      },
    768: {
        slidesPerView: 3,
        centeredSlides: false
    },
  };
  
  lockNext: boolean = false;
  lockPrev: boolean = true;

  constructor(private dataService: DataService) {}

  ngOnInit(): void {
    this.getLatestJobsItems();
  }

  private getLatestJobsItems() {
    let url = environment.apiUrl + '/Portal/CareerLatestJobsBlockList/GetCareerJobsItem';

    let request = {
      cultureCode: this.dataService.getCultureCode(),
      topItemsCount: this.pageData.topItemsCount,
      isAcademicApiEnabled: this.pageData.isAcademicApiEnabled,
      isK2ApiEnabled: this.pageData.isK2ApiEnabled,
    };

    this.dataService.getDataByToken(url, request).subscribe({
      next: (responseData) => {
        this.jobsItems = responseData;
        this.isLoaded = true;
      },
      error: (e) => {
        console.error(e);
      },
    });
  }

  prevSlide() {
    this.carousel.nativeElement.swiper.slidePrev(500);
    this.checkLockNavigation();
  }

  nextSlide() {
    this.carousel.nativeElement.swiper.slideNext(500);
    this.checkLockNavigation();
  }

  checkLockNavigation() {
    this.lockNext = this.carousel.nativeElement.swiper.isEnd;
    this.lockPrev = this.carousel.nativeElement.swiper.isBeginning;
  }
}
